import { createRefetchContainer, graphql } from 'react-relay';
import AvailabilityChecker from './AvailabilityChecker';

export default createRefetchContainer(
  AvailabilityChecker,
  {
    viewer: graphql`
      fragment AvailabilityCheckerContainer_viewer on User
        @argumentDefinitions(
          afterTime: { type: "ISO8601Type" }
          beforeTime: { type: "ISO8601Type" }
          returnEmptyConnection: { type: "Boolean", defaultValue: true }
        ) {
        ...AvailabilityCalendarContainer_viewer
        s_time_zone
        AvailabilityCheckerContainer_user_events: user_events(
          first: 99999
          visibility: [SHOW]
          return_empty_connection: $returnEmptyConnection
          after_time: $afterTime
          before_time: $beforeTime
        ) {
          edges {
            node {
              event {
                id
                title
              }
              booking_status
              start_at
              end_at
              user_event_segments(first: 99999) {
                edges {
                  node {
                    title
                    start_at
                    end_at
                    all_day
                    location
                    room
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
    query AvailabilityCheckerContainer_RefetchQuery(
      $afterTime: ISO8601Type!
      $beforeTime: ISO8601Type!
      $returnEmptyConnection: Boolean
    ) {
      viewer {
        ...AvailabilityCheckerContainer_viewer
          @arguments(
            afterTime: $afterTime
            beforeTime: $beforeTime
            returnEmptyConnection: $returnEmptyConnection
          )
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityChecker/AvailabilityCheckerContainer.js